import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import Modal from "react-bootstrap/Modal"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Input,
  Table,
   Spinner
} from "reactstrap"
import Select from "react-select"
import { useSelector, useDispatch } from "react-redux"
import PropTypes from "prop-types"
import { isEmpty } from "lodash"
import moment from "moment"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import api from "helpers/Api"
import ToolkitProvider from "react-bootstrap-table2-toolkit"

// import Multiselect from "multiselect-react-dropdown"

//components
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import * as manageInprogressAction from "../../../store/bWFuYWdlSW5wcm9ncmVzcw/actions"
import ButtonSpinner from "../../../components/ButtonSpinner"
import * as permissionAction from "../../../store/cGVybWlzc2lvbg/actions"
import * as ticketQueryAction from "../../../store/cmFpc2VUaWNrZXQ/actions"

const ManageTicketInprogress = (props) => {
  const { dispatch, searchBtnStyle } = props
  const title = "Manage Inprogress"

 
  const specificDispatch = useDispatch()
  const empId = localStorage.getItem("empId")

  useEffect(() => {
    dispatch(manageInprogressAction.loadRecordsMetaData())
    dispatch(manageInprogressAction.loadTicketQuery({
      status: "active" ,
      page:1,
      limit:50
    }))
    dispatch(ticketQueryAction.loadPriorityRecordsMetaData())
    dispatch(permissionAction.loadEmployee())
    dispatch(ticketQueryAction.loadSubLabelDetails({ status: "active" }))
    dispatch(
      ticketQueryAction.loadEmployeeLabels({
        status: "active",
        employeeId: empId,
      })
    )
  }, [])

  const ticketUpdate = useSelector((state) => state.manageInprogress)

  const { ticket_details = [] } = ticketUpdate

  const permissionUpdate = useSelector(
    (specificstate) => specificstate.permissionrequest
  )
  const { employee_list = [] } = permissionUpdate
  const [pageCount, setPageCount] = useState(false)
  const [pageChange, setPageChange] = useState(false)
  const [searchFilter, setSearchFilter] = useState(false)
  const [searchInput, setSearchInput] = useState([])
  const [downloadLoading, setDownloadLoading] = useState(false)
  const [loading, setLoading] = useState(false)
  
  //Session ticket store
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  //Raise ticket store
  const ticketStoreUpdate = useSelector((state) => state.raiseTicket)
  const {
    employee_labels = [],
    employee_sub_labels = [],
    priorityMetaData = {},
  } = ticketStoreUpdate

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //Offer initial state
  const [ticketData, setTicketData] = useState({
    title: "",
    fromDate: "",
    toDate: "",
  })

  //Handle change

  const handleChange = async (e) => {
    setTicketData({ ...ticketData, [e.target.name]: e.target.value })
  }

  //dropdown initial state
  const [employee, setEmployee] = useState([])
  const [ccEmployee, setCcEmployee] = useState([])
  const [employeeLabel, setEmployeeLabel] = useState([])
  const [employeeSubLabel, setEmployeeSubLabel] = useState([])

  const handleEmployeeLabel = (e) => {
    setEmployeeLabel(e)
    setEmployeeSubLabel([])
  }
  //Employee Label section

  const employeeLabelData =
    !isEmpty(employee_labels) && employee_labels.length > 0
      ? employee_labels.map((data) => {
          return {
            label: data.employeeLabelName,
            employeeName: data.employeeLabelName,
            employeeId: data.employeeId,
            value: data._id,
          }
        })
      : []

  const employeeSubLabelData =
    !isEmpty(employee_sub_labels) && employee_sub_labels.length > 0
      ? employee_sub_labels.map((data) => {
          return {
            label: data.employeeSubLabelName,
            employeeName: data.employeeName,
            employeeId: data.employeeId,
            employeeLabelId: data.employeeLabelId,
            value: data._id,
          }
        })
      : []
  //Employee List Options
  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        roleId: employee.roleId,
      }
    })

  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.name = element.name
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const employeeOptions = createOptions(employeeList)

  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  //reset functionalities
  const [resetEmployee, setResetEmployee] = useState(false)
  const [resetCcEmployee, setResetCcEmployee] = useState(false)
  const resetForm = () => {
    setSearchInput("")
    setEmployee([])
    setCcEmployee([])
    setEmployeeSubLabel([])
    setEmployeeLabel([])
    setResetEmployee(true)
    setResetCcEmployee(true)
    setTimeout(() => {
      setResetEmployee(false)
      setResetCcEmployee(false)
    }, 500)
    setTicketData({
      fromDate: "",
      toDate: "",
    })
    dispatch(manageInprogressAction.loadTicketQuery({
      page:1,
      limit:50
    }))
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)
  //dropdown options

  //Apply filter submit

  const applyFilter = (e) => {
    e.preventDefault()
    var searchEmployee = employee && employee ? employee.value : ""
    var searchEmployeeCC = ccEmployee && ccEmployee ? ccEmployee.value : ""
    var searchEmployeeLabel =
      employeeLabel && employeeLabel ? employeeLabel.value : ""
    var searchEmployeeSubLabel =
      employeeSubLabel && employeeSubLabel ? employeeSubLabel.value : ""

    var searchFromDate =
      ticketData && ticketData.fromDate
        ? moment(ticketData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      ticketData && ticketData.toDate
        ? moment(ticketData.toDate).format("YYYY-MM-DD")
        : ""

    var searchValue = {}
    searchValue.status = "active"
    searchValue.page = pageChange ? pageCount : 1
    searchValue.limit = sizePerPage ? sizePerPage : 50
    if (searchEmployee) {
      searchValue.reportingTo = searchEmployee
    }
    if (searchEmployeeCC) {
      searchValue.reportingBc = searchEmployeeCC
    }
    if (searchEmployeeLabel) {
      searchValue.employeeLabelId = searchEmployeeLabel
    }
    if (searchEmployeeSubLabel) {
      searchValue.employeeSubLabelId = searchEmployeeSubLabel
    }
    if (searchFromDate) {
      searchValue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.toDate = searchToDate
    }

    specificDispatch(manageInprogressAction.loadTicketQuery(searchValue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  let slNo = 0
  const manageTicketTable =
    !isEmpty(ticket_details) && ticket_details.data && ticket_details.data.length > 0
      ? ticket_details.data.map((data, index) => {
          slNo = slNo + 1
          const reportingBc =
            !isEmpty(data.reportingBc) && data.reportingBc.length > 0
              ? data.reportingBc.map((data) => data.name)
              : []
          const reportingBcName =
            !isEmpty(reportingBc) && reportingBc.length > 0
              ? reportingBc.join(",")
              : "--"

          const reportingTo =
            !isEmpty(data.reportingTo) && data.reportingTo.length > 0
              ? data.reportingTo.map((data) => data.name)
              : []
          const reportingToName =
            !isEmpty(reportingTo) && reportingTo.length > 0
              ? reportingTo.join(",")
              : "--"
          const attachments =
            !isEmpty(data.attachments) && data.attachments.length > 0
              ? data.attachments.map((data) => {
                  return {
                    attachments: data,
                  }
                })
              : []

          const createdAt = data.createdAt
            ? moment(data.createdAt)
                .format(`${dateFormate} hh:mm A`)
            : "--"

          const modifiedDetails =
            !isEmpty(data.queryChatDetail) && data.queryChatDetail.length > 0
              ? data.queryChatDetail[data.queryChatDetail.length - 1].updatedAt
              : []
          const processStatusName =
            !isEmpty(priorityMetaData) &&
            !isEmpty(priorityMetaData.processStatusOptions) &&
            priorityMetaData.processStatusOptions &&
            priorityMetaData.processStatusOptions.length > 0
              ? priorityMetaData.processStatusOptions.find(
                  (_) => _.processStatusId === data.queryStatus
                )
              : ""
          const modifiedDate =
            !isEmpty(modifiedDetails) && modifiedDetails.length > 0
              ? moment(modifiedDetails).format("DD-MM-YYYY hh:mm A")
              : "--"
              const regex = /(<([^>]+)>)/gi
              const result = data.description
              .replace(/&nbsp;/g, ' ')
              .replace(/&amp;/g, '&')
              .replace(regex, "")

          return {
            _id: data._id,
            sNo: slNo,
            colorCode: !isEmpty(processStatusName)
              ? processStatusName.colorCode
              : "",
            title: data.title,
            queryStatus: data.queryStatus,
            description: data.description ? result : "--",
            status: data.status,
            priority: !isEmpty(data.priority) ? data.priority : "--",
            employeeLabel: !isEmpty(data.labelName)
              ? data.labelName.map(m=>m).join(",")
              : "",
            employeeLabelId: !isEmpty(data.employeeLabelId)
              ? data.employeeLabel
              : "--",
            employeeSubLabel: !isEmpty(data.employeeSubLabelName)
              ? data.employeeSubLabelName
              : "",
            employeeSubLabelId: !isEmpty(data.employeeSubLabelId)
              ? data.employeeSubLabel
              : "--",
            reportingBc: reportingBcName,
            modifiedDate: modifiedDate,
            reportingTo: reportingToName,
            attachments: attachments,
            queryStatusName: data.queryStatusName,
            createdDate: createdAt,
            ticketNo: !isEmpty(data.refNo) ? data.refNo : "--",
            key: index,
          }
        })
      : []

  //Modal section

  const [attachmentModal, setAttachmentModal] = useState(false)
  const [attachmentDetails, setAttachmentDetails] = useState("")

 

  //columns for data table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
      // expandRow: false,
    },
    {
      dataField: "ticketNo",
      text: "Ticket No",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "modifiedDate",
      text: "Modified Date",
      sort: true,
      headerStyle: {
        minWidth: "164px",
      },
    },
    {
      dataField: "title",
      text: "Title",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "reportingTo",
      text: "To Members",
      headerStyle: {
        minWidth: "170px",
      },
      // expandRow: true,
    },
    {
      dataField: "reportingBc",
      text: "CC Members",
      sort: true,
      headerStyle: {
        minWidth: "175px",
      },
    },
    {
      dataField: "priority",
      text: "Priority",
      sort: true,
      headerStyle: {
        minWidth: "125px",
      },
    },
    {
      dataField: "employeeLabel",
      text: "Employee Label",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            {row.employeeLabel ? (
              <button
                style={{
                  backgroundColor: "#34c28f",
                  color: "white",
                  fontSize: "12px",
                  padding: "4px",
                  border: "none",
                  borderRadius: "4px",
                }}
              >
                {row.employeeLabel}
              </button>
            ) : (
              "--"
            )}
          </>
        )
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "employeeSubLabel",
      text: "Employee Sub Label",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            {row.employeeSubLabel ? (
              <button
                style={{
                  padding: "4px",
                }}
                className="btn btn-info"
              >
                {row.employeeSubLabel}
              </button>
            ) : (
              "--"
            )}
          </>
        )
      },
      headerStyle: {
        minWidth: "180px",
      },
    },
    {
      dataField: "createdDate",
      text: "Created Date",
      sort: true,
      headerStyle: {
        minWidth: "164px",
      },
    },
    {
      dataField: "description",
      text: "Description",
      sort: true,
      headerStyle: {
        minWidth: "200px",
      },
    },
    {
      dataField: "attachments",
      text: "Attachment",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <button
            className="btn btn-warning"
            onClick={() => {
              setAttachmentDetails(row.attachments)
              setAttachmentModal(true)
            }}
            style={{
              padding: "3px 5px",
            }}
          >
            Attachment
          </button>
        )
      },
      headerStyle: {
        minWidth: "148px",
      },
    },
    {
      dataField: "queryStatus",
      text: "Query Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <button
            style={{
              background: row.colorCode,
              border: "none",
              cursor: "pointer",
              color: "white",
              padding: "4px 6px",
              borderRadius: "4px",
            }}
          >
            {row.queryStatusName && row.status != 2
              ? row.queryStatusName
              : row.status == 2
              ? "Archieved"
              : row.queryStatusName}
          </button>
        )
      },
      headerStyle: {
        minWidth: "148px",
      },
    },
  ]
  const downloadFile = ({ data, fileName, fileType }) => {
    const blob = new Blob([data], { type: fileType })

    const a = document.createElement("a")
    a.download = fileName
    a.href = window.URL.createObjectURL(blob)
    const clickEvt = new MouseEvent("click", {
      view: window,
      bubbles: true,
      cancelable: true,
    })
    a.dispatchEvent(clickEvt)
    a.remove()
  }

  const exportToCsv = () => {
    var searchEmployee = employee && employee ? employee.value : ""
    var searchEmployeeCC = ccEmployee && ccEmployee ? ccEmployee.value : ""
    var searchEmployeeLabel =
      employeeLabel && employeeLabel ? employeeLabel.value : ""
    var searchEmployeeSubLabel =
      employeeSubLabel && employeeSubLabel ? employeeSubLabel.value : ""

    var searchFromDate =
      ticketData && ticketData.fromDate
        ? moment(ticketData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      ticketData && ticketData.toDate
        ? moment(ticketData.toDate).format("YYYY-MM-DD")
        : ""

    var searchValue = {}
    searchValue.status = "active"
   
    if (searchEmployee) {
      searchValue.reportingTo = searchEmployee
    }
    if (searchEmployeeCC) {
      searchValue.reportingBc = searchEmployeeCC
    }
    if (searchEmployeeLabel) {
      searchValue.employeeLabelId = searchEmployeeLabel
    }
    if (searchEmployeeSubLabel) {
      searchValue.employeeSubLabelId = searchEmployeeSubLabel
    }
    if (searchFromDate) {
      searchValue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.toDate = searchToDate
    }

    setPageLoad(!pageLoad)

    setDownloadLoading(true)
    api
      .post(`/get_all_query_excel_export`, searchValue)
      .then((response) => {
        const exportDataTable = !isEmpty(response.data.data)
          ? response.data.data.map((data, index) => {
            const reportingBc =
            !isEmpty(data.reportingBc) && data.reportingBc.length > 0
              ? data.reportingBc.map((data) => data.name)
              : []
          const reportingBcName =
            !isEmpty(reportingBc) && reportingBc.length > 0
              ? reportingBc.join(",")
              : "--"

          const reportingTo =
            !isEmpty(data.reportingTo) && data.reportingTo.length > 0
              ? data.reportingTo.map((data) => data.name)
              : []
          const reportingToName =
            !isEmpty(reportingTo) && reportingTo.length > 0
              ? reportingTo.join(",")
              : "--"
          const attachments =
            !isEmpty(data.attachments) && data.attachments.length > 0
              ? data.attachments.map((data) => {
                  return {
                    attachments: data,
                  }
                })
              : []

          const createdAt = data.createdAt
            ? moment(data.createdAt)
                .format(`${dateFormate} hh:mm A`)
            : "--"


          const modifiedDetails =
            !isEmpty(data.queryChatDetail) && data.queryChatDetail.length > 0
              ? data.queryChatDetail[data.queryChatDetail.length - 1].updatedAt
              : []
          const processStatusName =
            !isEmpty(priorityMetaData) &&
            !isEmpty(priorityMetaData.processStatusOptions) &&
            priorityMetaData.processStatusOptions &&
            priorityMetaData.processStatusOptions.length > 0
              ? priorityMetaData.processStatusOptions.find(
                  (_) => _.processStatusId === data.queryStatus
                )
              : ""
          const modifiedDate =
            !isEmpty(modifiedDetails) && modifiedDetails.length > 0
              ? moment(modifiedDetails).format("DD-MM-YYYY hh:mm A")
              : "--"
              const regex = /(<([^>]+)>)/gi
              const result = data.description
              .replace(/&nbsp;/g, ' ')
              .replace(/&amp;/g, '&')
              .replace(regex, "")

          return {
            _id: data._id,
            sNo: index + 1,
            colorCode: !isEmpty(processStatusName)
              ? processStatusName.colorCode
              : "",
            title: data.title,
            queryStatus: data.queryStatus,
            description: data.description ? result : "--",
            status: data.status,
            priority: !isEmpty(data.priority) ? data.priority : "--",
            employeeLabel: !isEmpty(data.labelName)
              ? data.labelName.map(m=>m).join(",")
              : "",
            employeeLabelId: !isEmpty(data.employeeLabelId)
              ? data.employeeLabel
              : "--",
            employeeSubLabel: !isEmpty(data.employeeSubLabelName)
              ? data.employeeSubLabelName
              : "",
            employeeSubLabelId: !isEmpty(data.employeeSubLabelId)
              ? data.employeeSubLabel
              : "--",
            reportingBc: reportingBcName,
            modifiedDate: modifiedDate,
            reportingTo: reportingToName,
            attachments: attachments,
            queryStatusName: data.queryStatusName,
            createdDate: createdAt,
            ticketNo: !isEmpty(data.refNo) ? data.refNo : "--",
            key: index,
          }
          })
          : []
        setTimeout(() => {
          let headerData = [
            "SNo,Ticket No,Modified Date,Title, To Members, CC Members,Priority,Employee Label, Employee Sub Label,Created Date,Description,Query Status",
          ]

          let usersCsv =
            !isEmpty(exportDataTable) &&
            exportDataTable.reduce((acc, user) => {
              const {
                sNo,
                ticketNo,
                modifiedDate,
                title,
                reportingTo,
                reportingBc,
                priority,
                employeeLabel,
                employeeSubLabel,
                createdDate,
                description,
                queryStatusName
                
               
              } = user
              acc.push([
                sNo,
                ticketNo,
                modifiedDate,
                title,
                reportingTo,
                reportingBc,
                priority,
                employeeLabel,
                employeeSubLabel,
                createdDate,
                description,
                queryStatusName
              ])

              return acc
            }, [])

          downloadFile({
            data: [...headerData, ...usersCsv].join("\n"),
            fileName: "ManageTicktets.csv",
            fileType: "text/csv",
          })
          setDownloadLoading(false)
        }, 2500)
        return response.data
      })
      .catch((error) => Promise.reject(error))
  }
  const handleClick = (e) => {
    e.preventDefault()
    setSearchFilter(true)

    dispatch(
      manageInprogressAction.loadTicketQuery({

        searchFilter: searchInput,
        page: pageChange ? pageCount : 1,
        limit: sizePerPage,
        status: "active"
      })
    )
    setTimeout(() => {
      setSearchFilter(false)
    }, 1200)
  }
  const RemotePagination = ({
    data,
    page,
    // sort,
    sizePerPage,
    onTableChange,
    totalSize,
  }) => (
    <div>
      <PaginationProvider
        pagination={paginationFactory({
          custom: true,
          page,
          // sort,
          sizePerPage,
          totalSize,
        })}
      >
        {({ paginationProps, paginationTableProps }) => (
          <div>
            <ToolkitProvider
              keyField="_id"
              data={data}
              columns={columns}
              search
              exportCSV
            >
              {() => (
                <div>
                  <Col md="12" xl="12" lg="12" sm="12" xs="12">
                    <Row className="d-flex flex-row">
                      <Col className="mb-3" md="4"></Col>
                      <Col
                        md="8"
                        style={{ marginBottom: "20px", marginTop: "-41px" }}
                      >
                      
                        <div
                          style={{
                            float: "right",
                            marginRight: "10px",
                          }}
                        >
                          <Button
                            className="btn btn-primary"
                            onClick={exportToCsv}
                            id="download"
                            style={{
                              backgroundColor: "#e40d8c",
                              color: "white",
                              border: "none",
                            }}
                          >
                            Download
                          </Button>
                        </div>
                      </Col>

                      <Col>
                        <BootstrapTable
                          remote
                          keyField="_id"
                          data={data}
                          id="ImportTable"
                          columns={columns}
                          responsive
                          noDataIndication={"No Data Found..."}
                          striped={true}
                          bordered={true}
                          onTableChange={onTableChange}
                          {...paginationTableProps}
                        />
                      </Col>
                    </Row>
                    <Row
                      style={{ marginTop: "5px" }}
                      className="align-items-md-center mt-30"
                    >
                      <Col className="inner-custom-pagination d-flex">
                        <div className="d-inline d-flex flex-row">
                          <SizePerPageDropdownStandalone {...paginationProps} />
                          <div
                            style={{
                              fontSize: "14px",
                              marginTop: "8px",
                              marginLeft: "4px",
                            }}
                          >
                            <PaginationTotalStandalone {...paginationProps} />
                          </div>
                        </div>
                        <div
                          className="text-md-right ms-auto"
                          style={{ zIndex: 0 }}
                        >
                          <PaginationListStandalone {...paginationProps} />
                        </div>
                      </Col>
                    </Row>
                  </Col>
                </div>
              )}
            </ToolkitProvider>
          </div>
        )}
      </PaginationProvider>
    </div>
  )
  const [pageLoad, setPageLoad] = useState(false)
  const [state, setState] = useState({
    sizePerPage: 50,
    page: 1,
    totalSize: ticket_details.length,
    data:
      !isEmpty(ticket_details) && ticket_details.length > 0
        ? ticket_details.slice(0, 50)
        : [],
  })
  const { sizePerPage, page } = state

  //Table Change

  const handleTableChange = (
    type,
    { page, sortField, sortOrder, currentIndex, sizePerPage }
  ) => {
    setPageCount(page)
    setPageChange(true)
    setPageLoad(!pageLoad)
    let result =
      !isEmpty(ticket_details) && ticket_details.length > 0
        ? ticket_details
        : []
    if (
      !isEmpty(ccEmployee) ||
      !isEmpty(employee) ||
      !isEmpty(employeeSubLabel) ||
      !isEmpty(employeeLabel) ||
      !isEmpty(ticketData.fromDate) ||
      !isEmpty(ticketData.toDate)
    ) {
      var searchEmployee = employee && employee ? employee.value : ""
    var searchEmployeeCC = ccEmployee && ccEmployee ? ccEmployee.value : ""
    var searchEmployeeLabel =
      employeeLabel && employeeLabel ? employeeLabel.value : ""
    var searchEmployeeSubLabel =
      employeeSubLabel && employeeSubLabel ? employeeSubLabel.value : ""

    var searchFromDate =
      ticketData && ticketData.fromDate
        ? moment(ticketData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      ticketData && ticketData.toDate
        ? moment(ticketData.toDate).format("YYYY-MM-DD")
        : ""

    var searchValue = {}
    searchValue.status = "active"
    searchValue.page = page
    searchValue.limit = sizePerPage ? sizePerPage : 50
    if (searchEmployee) {
      searchValue.reportingTo = searchEmployee
    }
    if (searchEmployeeCC) {
      searchValue.reportingBc = searchEmployeeCC
    }
    if (searchEmployeeLabel) {
      searchValue.employeeLabelId = searchEmployeeLabel
    }
    if (searchEmployeeSubLabel) {
      searchValue.employeeSubLabelId = searchEmployeeSubLabel
    }
    if (searchFromDate) {
      searchValue.fromDate = searchFromDate
    }
    if (searchToDate) {
      searchValue.toDate = searchToDate
    }
      /////

      setPageLoad(!pageLoad)
      setLoading(true)
      specificDispatch(manageInprogressAction.loadTicketQuery(searchValue))
    } else {
      dispatch(
        manageInprogressAction.loadTicketQuery({
          page: page,
          limit: sizePerPage,
          status: "active"
        })
      )
      setLoading(true)
      setPageLoad(!pageLoad)
    }
    // setPageCount(page)
    setTimeout(() => {
      setLoading(false)
    }, 2000)
    if (sortOrder === "asc") {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return 1
        } else if (b[sortField] > a[sortField]) {
          return -1
        }
        return 0
      })
    } else {
      result = result.sort((a, b) => {
        if (a[sortField] > b[sortField]) {
          return -1
        } else if (b[sortField] > a[sortField]) {
          return 1
        }
        return 0
      })
    }

    setState(() => ({
      page,
      data: result.slice(currentIndex, currentIndex + sizePerPage),
      totalSize: result.length,
      sizePerPage,
    }))
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Tickets"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="">
                        <Label
                          className="form-label"
                          htmlFor={"Event From Date"}
                        >
                          {"To Members"}
                        </Label>
                        <ReactSearchAutocomplete
                          key={resetEmployee}
                          name="employee"
                          items={employeeOptions}
                          value={employee}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setEmployee(e)}
                          onChange={(e) => setEmployee(e.target.value)}
                          placeholder="Enter To Members"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>{" "}
                      <Col xl="3" lg="3" md="3" sm="3" xs="3" className="">
                        <Label
                          className="form-label"
                          htmlFor={"Event From Date"}
                        >
                          {"CC Members"}
                        </Label>
                        <ReactSearchAutocomplete
                          key={resetCcEmployee}
                          name="ccEmployee"
                          items={employeeOptions}
                          value={ccEmployee}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setCcEmployee(e)}
                          onChange={(e) => setCcEmployee(e.target.value)}
                          placeholder="Enter CC Members"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>{" "}
                      <Col lg="3" md="3" sm="12" xs="12">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Employee Label"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="employeeLabel"
                          value={employeeLabel}
                          options={employeeLabelData ? employeeLabelData : []}
                          onChange={(e) => {
                            handleEmployeeLabel(e)
                            if (e) {
                              dispatch(
                                ticketQueryAction.loadEmployeeSubLabels({
                                  status: "active",
                                  employeeId: empId,
                                  employeeLabelId: e.value,
                                })
                              )
                            }
                          }}
                          placeholder="Select Employee Label"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Employee Sub Label"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="employeeSubLabel"
                          value={employeeSubLabel}
                          options={
                            employeeSubLabelData ? employeeSubLabelData : []
                          }
                          onChange={(e) => setEmployeeSubLabel(e)}
                          placeholder="Select Employee Sub Label"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={ticketData.fromDate}
                          max={ticketData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={ticketData.toDate}
                          min={ticketData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-5">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                <div
                    className="d-flex flex-row"
                    style={{ marginTop: "20px" }}
                  >
                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                      <form onSubmit={handleClick} className="d-flex flex-row">
                        <div style={searchBtnStyle || null}>
                          <Input
                            type="text"
                            name="searchInput"
                            value={searchInput}
                            onChange={(e) => setSearchInput(e.target.value)}
                            className="form-control"
                            placeholder="Search"
                            style={{ position: "relative" }}
                          />
                          <i
                            className="bx bx-search-alt"
                            style={{
                              position: "absolute",
                              top: "54px",
                              left: "41px",
                              fontSize: "13px",
                            }}
                          />
                        </div>
                        <button
                          className="btn btn-success mx-2"
                          type="submit"
                          style={{
                            background: searchFilter ? "#2ca67a" : "",
                            color: searchFilter ? "#ffffff" : "",
                          }}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </form>
                    </div>
                  </div>{" "}
                  <RemotePagination
                    data={manageTicketTable}
                    page={page}
                    sizePerPage={sizePerPage}
                    totalSize={
                      ticket_details.totalDataCount
                        ? ticket_details.totalDataCount
                        : 0
                    }
                    onTableChange={handleTableChange}
                  />
             
                </CardBody>
              </Card>
            </Col>
          </Row>
          {attachmentModal && (
            <Modal
              backdrop="static"
              show={attachmentModal}
              onHide={() => setAttachmentModal(false)}
              size="md"
            >
              <Modal.Header style={{ background: "#e40d8c", color: "white" }}>
                Attachments
              </Modal.Header>
              <Modal.Body>
                <Table>
                  <thead>
                    <tr>
                      <th>S.No</th>
                      <th>Attachment</th>
                    </tr>
                  </thead>
                  <tbody>
                    {!isEmpty(attachmentDetails) &&
                    attachmentDetails.length > 0 ? (
                      attachmentDetails.map((data, index) => {
                        const attachment = !isEmpty(data.attachments)
                          ? data.attachments
                          : ""
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                              <a
                                onClick={() =>
                                  window.open(attachment, "_blank")
                                }
                              >
                                <span
                                  style={{
                                    textDecoration: "underline",
                                    color: "#E40D8C",
                                  }}
                                >
                                  View
                                </span>
                              </a>
                            </td>
                          </tr>
                        )
                      })
                    ) : (
                      <tr>
                        <td></td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              </Modal.Body>
              <Modal.Footer>
                <div className="d-flex flex-row">
                  <Button
                    className="btn btn-danger"
                    onClick={() => setAttachmentModal(false)}
                  >
                    Close
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
                 {downloadLoading ? (
            <Modal
              show={downloadLoading}
              style={{ width: "7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
          {loading ? (
            <Modal
              show={loading}
              style={{ width: "7%", margin: "18% 50%" }}
            >
              <Modal.Body>
                <Spinner
                  as="span"
                  animation="grow"
                  size="lg"
                  role="status"
                  aria-hidden="true"
                  variant="success"
                  className="mx-2"
                  color="success"
                />
              </Modal.Body>
            </Modal>
          ) : (
            ""
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

ManageTicketInprogress.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
  searchBtnStyle: PropTypes.any,
  disableMultiSelect: PropTypes.any,
  title: PropTypes.any,
  onSearch: PropTypes.func,
  onExport: PropTypes.func,
  pageClick: PropTypes.any,
  data: PropTypes.array.isRequired,
  page: PropTypes.number.isRequired,
  loading: PropTypes.bool.isRequired,
  totalSize: PropTypes.number.isRequired,
  sizePerPage: PropTypes.number.isRequired,
  onTableChange: PropTypes.func.isRequired,
  location: PropTypes.any
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ManageTicketInprogress)
)
